<template lang="pug">
.login
  .area
    ul.circles
      li(v-for="i in 10")

  v-snackbar(top, color="error", :timeout="-1", v-model="hasError")
    .overline {{ errorMessage.charAt(0).toUpperCase() + errorMessage.slice(1) }}
    template(v-slot:action="{ attrs }")
      v-btn(icon, dark, v-bind="attrs", @click="hasError = false")
        v-icon mdi-close

  v-snackbar(top, color="success", :timeout="-1", v-model="hasSuccess")
    .overline {{ successMessage.charAt(0).toUpperCase() + successMessage.slice(1) }}
    template(v-slot:action="{ attrs }")
      v-btn(icon, dark, v-bind="attrs", @click="hasSuccess = false")
        v-icon mdi-close

  v-card(style="width: 450px; height: 500px")
    v-card-title.py-6.justify-center
      div(style="width: 200px")
        v-img(src="@/assets/nb_final.png", contain)

    v-tabs(background-color="transparent", grow, v-model="currentTabIndex")
      v-tab(v-for="tab in tabs", :key="tab") {{ tab }}

    v-tabs-items(v-model="currentTabIndex")
      v-tab-item(key="Sign in")
        Login(@error="throwError", @success="throwSuccess")
      v-tab-item(key="Sign up")
        Registration(@error="throwError", @success="throwSuccess")
</template>

<script>
import Login from "@/components/Login";
import Registration from "@/components/Registration";

export default {
  name: "auth",

  components: {
    Login,
    Registration,
  },

  mounted() {
    if (this.$route.query.token) this.activateAccount();
    if (this.$route.query.company_id) this.currentTabIndex = 1;
  },

  data() {
    return {
      currentTabIndex: this.$route.name === "Login employee" ? 1 : 0,
      tabs: ["Sign in", "Sign up"],
      hasError: false,
      hasSuccess: false,
      errorMessage: "",
      successMessage: "",
    };
  },

  methods: {
    throwError(text) {
      this.hasError = true;
      this.errorMessage = text;
    },

    throwSuccess(text) {
      this.hasSuccess = true;
      this.successMessage = text;
    },

    activateAccount() {
      this.loading = true;
      this.axios
        .post("/auth/activate", { Token: this.$route.query.token })
        .then(() => {
          this.hasSuccess = true;
          this.successMessage = "Account activated succesfully";
        })
        .catch((e) => {
          this.hasError = true;
          this.errorMessage = e?.response.data.Error ?? "Network error";
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="sass" scoped>
.login
  height: 100vh
  overflow: hidden
  display: flex
  justify-content: center
  align-items: center
  background-size: cover
</style>

<style scoped>
.area {
  background: #50bdc1;
  background: -webkit-linear-gradient(to left, #8f94fb, #50bdc1);
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.circles {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.circles li {
  position: absolute;
  display: block;
  list-style: none;
  width: 20px;
  height: 20px;
  background: rgba(255, 255, 255, 0.2);
  animation: animate 25s linear infinite;
  bottom: -150px;
}

.circles li:nth-child(1) {
  left: 25%;
  width: 80px;
  height: 80px;
  animation-delay: 0s;
}

.circles li:nth-child(2) {
  left: 10%;
  width: 20px;
  height: 20px;
  animation-delay: 2s;
  animation-duration: 12s;
}

.circles li:nth-child(3) {
  left: 70%;
  width: 20px;
  height: 20px;
  animation-delay: 4s;
}

.circles li:nth-child(4) {
  left: 40%;
  width: 60px;
  height: 60px;
  animation-delay: 0s;
  animation-duration: 18s;
}

.circles li:nth-child(5) {
  left: 65%;
  width: 20px;
  height: 20px;
  animation-delay: 0s;
}

.circles li:nth-child(6) {
  left: 75%;
  width: 110px;
  height: 110px;
  animation-delay: 3s;
}

.circles li:nth-child(7) {
  left: 35%;
  width: 150px;
  height: 150px;
  animation-delay: 7s;
}

.circles li:nth-child(8) {
  left: 50%;
  width: 25px;
  height: 25px;
  animation-delay: 15s;
  animation-duration: 45s;
}

.circles li:nth-child(9) {
  left: 20%;
  width: 15px;
  height: 15px;
  animation-delay: 2s;
  animation-duration: 35s;
}

.circles li:nth-child(10) {
  left: 85%;
  width: 150px;
  height: 150px;
  animation-delay: 0s;
  animation-duration: 11s;
}

@keyframes animate {
  0% {
    transform: translateY(0) rotate(0deg);
    opacity: 1;
    border-radius: 0;
  }

  100% {
    transform: translateY(-1000px) rotate(720deg);
    opacity: 0;
    border-radius: 50%;
  }
}
</style>

